import { BuildingIcon } from "@phosphor-icons/react/Building";

// Marks a saved location as one of the company's own branches.
export function LocationsBranchMarker() {
  return (
    <BuildingIcon
      className="ml-2 inline-block h-2.5 w-2.5 text-content-muted"
      weight="fill"
    />
  );
}
